<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokContentProps {
    blok: StoryblokContent;
}

// PROPS
const { blok } = defineProps<StoryblokContentProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['maxWidth', 'align', 'rounded']));

// DATA
const variantClasses = computed<string[]>(() => {
    if (blok.variant === 'outline') return ['bg-default', 'ring', 'ring-default', 'p-6'];
    if (blok.variant === 'soft') return ['bg-elevated/80', 'p-6'];

    return [];
});
</script>

<template>
    <div v-if="blok.body && blok.body.length" v-editable="blok" :class="[...classes, ...variantClasses]">
        <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
    </div>
</template>
